import { SCROLL_DIRECTION } from './constants';

const rafDebouce = (callback?: any) => {
  let requestId;

  return () => {
    if (requestId) {
      cancelAnimationFrame(requestId);
    }

    requestId = requestAnimationFrame(() => {
      callback();
      requestId = null;
    });
  };
};

const setupScrollDirectionListener = (onScrollDirectionChange?: any) => {
  let scrollDirection;
  let prevScrollY = (window as any).scrollY;

  const handleScroll = () => {
    const currentScrollY = (window as any).scrollY;

    if (currentScrollY > prevScrollY) {
      scrollDirection = SCROLL_DIRECTION.DOWN;
    } else if (currentScrollY < prevScrollY) {
      scrollDirection = SCROLL_DIRECTION.UP;
    }

    prevScrollY = currentScrollY;
    onScrollDirectionChange(scrollDirection);
  };

  const debounceScrollDirection = rafDebouce(handleScroll);
  (window as any).addEventListener('scroll', debounceScrollDirection);

  return () => (window as any).removeEventListener('scroll', debounceScrollDirection);
};


export default setupScrollDirectionListener;
